import apiClient from './client';

export interface AdvisorCitation {
  label: string;
  url: string;
}

export interface AdvisorChatResponse {
  reply: string;
  citations: AdvisorCitation[];
  sessionId: string;
}

export async function sendAdvisorMessage(
  userId: string,
  message: string,
  sessionId?: string
): Promise<AdvisorChatResponse> {
  const res = await apiClient.post<AdvisorChatResponse>(
    `/analytics/advisor/${userId}/chat`,
    { message, sessionId }
  );
  return res.data;
}
